<template>
    <div class="search-results" ref="results" :class="{ 'from-widget':fromWidget }">
        <div v-if="results.packages.length">
            <h2>Packages</h2>
            <a v-for="packageItem in results.packages" :href="packageItem._links[frontendType][linkKey]">
                <strong>{{ packageItem.project }}:</strong> {{ packageItem.name }} - {{ packageItem.client.name }} ({{ packageItem.reference }})
                <small>{{ packageItem.address }} | <strong>{{ packageItem.status.name }}</strong></small>
            </a>
        </div>
        <div v-if="results.archives.length">
            <h2>Archived Packages</h2>
            <a v-for="packageItem in results.archives" href="#" :href="packageItem._links[frontendType][linkKey]">
                {{ packageItem.name }} - {{ packageItem.client.name }} ({{ packageItem.reference }})
                <small>{{ packageItem.address }} | <strong>{{ packageItem.status.name }}</strong></small>
            </a>
        </div>
        <div v-if="results.companies.length">
            <h2>Companies</h2>
            <a v-for="company in results.companies" href="#" :href="company._links.classic.view">{{ company.name }}</a>
        </div>
        <div v-if="results.people.length">
            <h2>People</h2>
            <a v-for="person in results.people" href="#" :href="person._links.classic.view">{{ person.name }}</a>
        </div>
        <div v-if="results.pos.length">
            <h2>Purchase Orders</h2>
            <a v-for="po in results.pos" href="#" :href="po._links.classic.view">
                PO #{{ po.reference }}
                <small v-if="po.supplier">{{ po.supplier }}</small>
                <small v-if="po.raised">Raised: {{ po.raised }}</small>
                <small>£{{ po.costs.gross }}</small>
            </a>
        </div>
        <div v-if="results.pis.length">
            <h2>Purchase Invoices</h2>
            <a v-for="pi in results.pis" href="#" :href="pi._links.classic.view">
                PI #{{ pi.supplier_reference }}
                <small v-if="pi.supplier">{{ pi.supplier }}</small>
                <small v-if="pi.raised">Invoice Date: {{ pi.raised }}</small>
                <small>£{{ pi.costs.gross }}</small>
            </a>
        </div>
        <div v-if="results.sis.length">
            <h2>Sales Invoices</h2>
            <a v-for="si in results.sis" href="#" :href="si._links.classic.view">
                SI #{{ si.reference }}
                <small v-if="si.client">{{ si.client }}</small>
                <small v-if="si.raised">Invoice Date: {{ si.raised }}</small>
                <small>£{{ si.costs.gross }}</small>
            </a>
        </div>
        <div v-if="results.sos.length">
            <h2>Sales Orders</h2>
            <a v-for="so in results.sos" href="#" :href="so._links.classic.view">
                SO #{{ so.client_reference }}
                <small v-if="so.client">{{ so.client }}</small>
                <small v-if="so.raised">Raised: {{ so.raised }}</small>
                <small>£{{ so.costs.gross }}</small>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['results', 'fromWidget','route'],
        watch: {
            results: function (results) {
                this.reloadStickyHeaders();
            }
        },
        computed: {
            frontendType: function(){
                return 'frontend'

                if (this.route) {
                    return 'frontend'
                }

                return 'classic';
            },
            linkKey: function () {
                if (this.route) {
                    return this.route;
                }

                return 'view';
            }
        },
        methods: {
            getWindowElement: function () {
                return $(this.$refs.results).first();
            },
            reloadStickyHeaders: function () {
                var that = this;
                setTimeout(function () {
                    window.hambroHeaders.init($(".search-results h2"), that.getWindowElement());
                }, 100);
            }
        },
        mounted: function () {
            this.reloadStickyHeaders();
        }
    }

</script>

<style scoped lang="scss">
  @import '../../sass/setup';

  .search-results {
    &.from-widget{
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      height: calc(100vh - 118px);
      overflow-x: hidden;
    }
    > div {
      margin-bottom: 2.5em;
      position: relative;
    }
    h2 {
      font-size: 17px;
      position: relative;
      z-index: 1;
      &.fixed {
        position: fixed;
        width: 100%;
        @include mobile(){
          top: 113px;
        }
        @include desktop() {
          width: 248px;
          margin-left: -13px;
          padding-left: 13px;
          top:50px;
        }
        box-sizing: border-box;
        z-index: 0;
        background-color: #fff;
        padding-top: 13px;
        padding-bottom: 13px;
        margin-top: -13px;
        &.absolute {
          position: absolute;
        }
      }
    }

    a {
      color: $brand !important;
      text-decoration: none;
      padding: 0.3em 0.5em 0;
      display: block;
      margin: 0.5em -0.5em 0.5em;
      border-radius: 0.3em;
      &:hover {
        background-color: $yellow;
      }
      &:focus {
        background-color: #fccf0066;
      }
    }
    small {
      display: block;
      color: #999;
    }
  }
</style>
